export default {"src":"/_next/static/media/GATE.f2378525.svg","height":24,"width":107,"blurWidth":0,"blurHeight":0};